import { jsxs, jsx, Fragment } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { theme } from "../../../foundations/theme.es.js";
import { formatCurrency } from "../../../utils/formatting/formatting.es.js";
import { l as lodashExports } from "../../../../node_modules/lodash/lodash.es.js";
import { memo } from "react";
import { Typography } from "../../typography/typography.es.js";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
function generateIseeCardContent({
  title,
  value,
  currency
}) {
  const isValueParsableToNumber = !lodashExports.isNaN(Number(value));
  if (isValueParsableToNumber) {
    value = formatCurrency(Number(value));
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Typography, { color: "textSecondary", sx: theme.typography.body2, children: title }),
    /* @__PURE__ */ jsxs(Typography, { sx: theme.typography.body1, display: Displaying.flex, children: [
      value,
      isValueParsableToNumber && /* @__PURE__ */ jsx(Typography, { marginLeft: Spacing["250"], color: "textSecondary", children: currency })
    ] })
  ] });
}
const IseeCardContent = memo(generateIseeCardContent);
export {
  IseeCardContent
};
//# sourceMappingURL=isee-content.es.js.map
